'use client'
import { cn } from 'ui'

export const AutosignLogo = ({
  className,
  variant = 'black',
}: {
  className?: string
  variant?: 'black' | 'white'
}) => {
  switch (variant) {
    case 'black':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          fill='none'
          viewBox='0 0 75 14'
          className={cn(className)}
        >
          <path
            fill='#0F1119'
            d='M0 8.644c0-1.565 1.247-2.34 2.903-2.34h2.603v-.568c0-1.09-.631-1.77-1.909-1.77-1.247 0-1.925.664-2.16 1.66l-1.17-.38c.36-1.298 1.405-2.354 3.346-2.354 1.956 0 3.123 1.074 3.123 2.923v3.492c0 .316.158.474.442.474h.71v1.06H6.8c-.694 0-1.152-.412-1.152-1.076v-.079h-.19c-.33.617-.977 1.375-2.57 1.375C1.246 11.06 0 10.192 0 8.644zM5.506 7.49v-.174H2.948c-.994 0-1.704.427-1.704 1.298 0 .872.71 1.375 1.783 1.375 1.485-.002 2.479-.919 2.479-2.5zM9.292 7.79V3.114h1.246v4.582c0 1.533.821 2.197 2.13 2.197 1.467 0 2.524-.98 2.524-2.892V3.113h1.247v7.727h-1.215V9.528h-.221c-.347.743-1.088 1.454-2.664 1.454-1.706 0-3.047-1.122-3.047-3.191zM20.51 9.481V4.204h-2.32V3.113h2.32V.363h1.246v2.75h2.524v1.09h-2.524v5.073c0 .316.126.474.457.474h1.72v1.09h-2.051c-.884 0-1.373-.521-1.373-1.359zM25.636 7.08v-.206c0-2.418 1.61-3.982 3.945-3.982 2.334 0 3.944 1.564 3.944 3.982v.205c0 2.418-1.61 3.982-3.944 3.982-2.335 0-3.945-1.564-3.945-3.982zm6.642-.032v-.145c0-1.77-1.073-2.891-2.697-2.891-1.641 0-2.698 1.121-2.698 2.891v.145c0 1.77 1.073 2.891 2.698 2.891 1.624 0 2.697-1.121 2.697-2.891zM35.26 8.296l1.183-.269c.22 1.515 1.262 1.992 2.43 1.992 1.152 0 1.877-.49 1.877-1.28s-.679-1.044-1.8-1.25l-.649-.11c-1.512-.268-2.698-.885-2.698-2.275s1.168-2.212 2.934-2.212c1.736 0 2.856.821 3.169 2.26l-1.168.3c-.189-1.106-.962-1.515-2.004-1.515-1.056 0-1.703.41-1.703 1.154 0 .743.615 1.027 1.593 1.2l.648.112c1.626.284 2.903.793 2.903 2.29 0 1.515-1.215 2.37-3.107 2.37-1.92-.002-3.34-.856-3.608-2.767zM43.747.964c0-.569.41-.964.947-.964.552 0 .962.395.962.964 0 .553-.41.948-.962.948a.92.92 0 01-.947-.948zm.332 2.149h1.246v7.727H44.08V3.113zM47.565 6.794c0-2.417 1.625-3.902 3.644-3.902 1.626 0 2.43.743 2.84 1.501h.22v-1.28h1.184v9.528c0 .838-.473 1.359-1.357 1.359H48.86v-1.106h4.906c.316 0 .473-.158.473-.474V9.48h-.22c-.379.696-1.183 1.438-2.81 1.438-2.016 0-3.644-1.485-3.644-3.903v-.222zm6.673.174v-.126c0-1.785-1.104-2.844-2.697-2.844-1.594 0-2.714 1.059-2.714 2.844v.126c0 1.786 1.12 2.845 2.714 2.845 1.577 0 2.697-1.059 2.697-2.845zM58.072 3.113h1.215v1.311h.22c.332-.742 1.073-1.453 2.651-1.453 1.704 0 3.06 1.122 3.06 3.192v4.677h-1.246V6.258c0-1.533-.836-2.197-2.13-2.197-1.483 0-2.523.98-2.523 2.892v3.887h-1.247V3.113z'
          ></path>
          <path fill='#C084FC' d='M67.648 11.614H75v1.154h-7.35v-1.154z'></path>
        </svg>
      )

    case 'white':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 1123.68 309.51'
          className={cn(className)}
        >
          <path
            d='M37.06 171.9c0-21.69 17.31-32.43 40.31-32.43h36.15v-7.88c0-15.12-8.77-24.54-26.51-24.54-17.31 0-26.73 9.2-30 23l-16.23-5.25c5-18 19.5-32.65 46.45-32.65 27.16 0 43.37 14.9 43.37 40.53v48.42c0 4.38 2.19 6.57 6.14 6.57h9.86v14.68h-15.12c-9.64 0-16-5.7-16-14.9v-1.1h-2.63c-4.6 8.55-13.58 19.06-35.71 19.06-22.77 0-40.08-12.04-40.08-33.51Zm76.46-16v-2.41H78c-13.81 0-23.66 5.92-23.66 18s9.85 19.06 24.75 19.06c20.62-.03 34.43-12.74 34.43-34.65ZM166.1 160.07V95.22h17.3v63.53c0 21.25 11.4 30.45 29.58 30.45 20.37 0 35.05-13.58 35.05-40.09V95.22h17.31v107.13h-16.87v-18.19h-3.07c-4.82 10.3-15.11 20.16-37 20.16-23.68 0-42.3-15.56-42.3-44.25ZM321.86 183.51v-73.17h-32.2V95.22h32.2V57.1h17.31v38.12h35.05v15.12h-35.05v70.32c0 4.38 1.75 6.57 6.35 6.57h23.88v15.12h-28.48c-12.27 0-19.06-7.23-19.06-18.84ZM393.06 150.21v-2.85c0-33.52 22.35-55.21 54.77-55.21s54.77 21.69 54.77 55.21v2.85c0 33.52-22.35 55.2-54.77 55.2s-54.77-21.68-54.77-55.2Zm92.23-.44v-2c0-24.54-14.9-40.09-37.46-40.09-22.78 0-37.46 15.55-37.46 40.09v2c0 24.54 14.9 40.09 37.46 40.09s37.46-15.55 37.46-40.09ZM526.7 167.08l16.43-3.73c3.06 21 17.52 27.61 33.74 27.61 16 0 26.06-6.8 26.06-17.75s-9.42-14.46-25-17.31l-9-1.53c-21-3.72-37.46-12.27-37.46-31.55s16.21-30.67 40.74-30.67c24.1 0 39.66 11.39 44 31.33L600 127.64c-2.63-15.33-13.37-21-27.83-21-14.67 0-23.66 5.7-23.66 16s8.55 14.24 22.13 16.65l9 1.54c22.57 3.94 40.31 11 40.31 31.76 0 21-16.87 32.86-43.15 32.86-26.66-.04-46.38-11.87-50.1-38.37ZM644.56 65.43c0-7.89 5.69-13.37 13.14-13.37 7.67 0 13.37 5.48 13.37 13.37 0 7.66-5.7 13.14-13.37 13.14a12.78 12.78 0 0 1-13.14-13.14Zm4.6 29.79h17.31v107.13h-17.31ZM697.57 146.26c0-33.51 22.57-54.11 50.61-54.11 22.57 0 33.74 10.3 39.43 20.82h3.07V95.22h16.43v132.1c0 11.61-6.57 18.84-18.84 18.84h-72.73v-15.33h68.13q6.57 0 6.57-6.58v-40.74h-3.07c-5.25 9.64-16.42 19.93-39 19.93-28 0-50.61-20.59-50.61-54.11Zm92.67 2.41v-1.75c0-24.75-15.33-39.43-37.46-39.43s-37.68 14.68-37.68 39.43v1.75c0 24.76 15.55 39.44 37.68 39.44 21.91 0 37.46-14.68 37.46-39.44ZM843.48 95.22h16.87v18.18h3.06c4.6-10.29 14.9-20.15 36.81-20.15 23.66 0 42.5 15.55 42.5 44.25v64.85h-17.31v-63.53c0-21.25-11.61-30.46-29.57-30.46-20.6 0-35.05 13.59-35.05 40.1v53.89h-17.31Z'
            style={{
              fill: '#fff',
            }}
          />
          <path
            d='M976.46 213.08h102.08v16H976.46Z'
            style={{
              fill: '#c084fc',
            }}
          />
        </svg>
      )

    default:
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='68'
          height='13'
          fill='none'
          viewBox='0 0 68 13'
          className={cn(className)}
        >
          <path
            fill='#F4F4F5'
            d='M3.472 10.196c-1.47 0-2.59-.784-2.59-2.184 0-1.4 1.12-2.128 2.632-2.128h2.1v-.448c0-.798-.476-1.33-1.484-1.33-.994 0-1.484.518-1.652 1.26l-1.344-.434c.336-1.092 1.246-2.03 3.01-2.03 1.792 0 2.884.952 2.884 2.632v2.842c0 .28.14.42.392.42h.588V10H6.93c-.644 0-1.092-.364-1.092-.938V9.02h-.224c-.21.448-.714 1.176-2.142 1.176zm.21-1.19c1.148 0 1.932-.7 1.932-1.862v-.14H3.598c-.77 0-1.274.336-1.274.966 0 .63.504 1.036 1.358 1.036zm8.196 1.12c-1.582 0-2.716-1.106-2.716-2.884V3.098h1.442v4.046c0 1.19.63 1.75 1.694 1.75 1.19 0 1.96-.812 1.96-2.31V3.098H15.7V10h-1.414V8.964h-.224c-.266.574-.868 1.162-2.184 1.162zM20.422 10c-.854 0-1.372-.532-1.372-1.386V4.316h-1.904V3.098h1.904V.816h1.442v2.282h2.058v1.218h-2.058v4.046c0 .28.126.42.392.42h1.442V10h-1.904zm6.81.196c-2.072 0-3.57-1.344-3.57-3.542v-.21c0-2.184 1.498-3.542 3.57-3.542s3.584 1.358 3.584 3.542v.21c0 2.198-1.512 3.542-3.584 3.542zm0-1.288c1.26 0 2.142-.854 2.142-2.296v-.126c0-1.428-.868-2.296-2.142-2.296-1.26 0-2.128.868-2.128 2.296v.126c0 1.442.868 2.296 2.128 2.296zm8.207 1.288c-1.764 0-2.996-.784-3.248-2.366l1.344-.322c.196 1.162.98 1.526 1.904 1.526.91 0 1.428-.378 1.428-.952 0-.56-.476-.77-1.372-.938l-.49-.084c-1.4-.252-2.52-.798-2.52-2.1s1.05-2.058 2.66-2.058c1.554 0 2.59.742 2.884 1.946l-1.344.378c-.154-.84-.728-1.148-1.54-1.148-.798 0-1.26.308-1.26.826 0 .56.462.77 1.218.91l.49.084c1.498.266 2.688.714 2.688 2.114 0 1.386-1.12 2.184-2.842 2.184zm5.255-8.036c-.574 0-.994-.392-.994-.98s.42-.98.994-.98c.56 0 .994.392.994.98s-.434.98-.994.98zM39.966 10V3.098h1.442V10h-1.442zm3.246-3.416v-.21c0-2.17 1.456-3.472 3.206-3.472 1.344 0 2.002.616 2.338 1.19h.224v-.994h1.4v8.316c0 .854-.532 1.386-1.386 1.386h-4.648v-1.26h4.2c.266 0 .406-.14.406-.42V8.922h-.224c-.308.532-.952 1.12-2.31 1.12-1.75 0-3.206-1.302-3.206-3.458zm3.598 2.198c1.246 0 2.156-.826 2.156-2.24v-.126c0-1.414-.896-2.24-2.156-2.24-1.246 0-2.142.826-2.142 2.24v.126c0 1.414.91 2.24 2.142 2.24zM52.504 10V3.098h1.413v1.036h.224c.267-.56.869-1.148 2.199-1.148 1.567 0 2.701 1.092 2.701 2.87V10H57.6V5.968c0-1.204-.63-1.75-1.68-1.75-1.19 0-1.974.812-1.974 2.296V10h-1.442z'
          ></path>
          <path
            fill='#DCF764'
            d='M61.047 11.988v-1.302h6.692v1.302h-6.692z'
          ></path>
        </svg>
      )
  }
}

export const AutosignShortLogo = ({
  className,
  variant = 'white-purple',
}: {
  className?: string
  variant?:
    | 'white-purple'
    | 'white-lime'
    | 'black-lime'
    | 'black-purple'
    | 'black-white'
}) => {
  switch (variant) {
    case 'white-purple':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 200 200'
          className={cn(className)}
        >
          <path
            d='M72 135.22h56.1V144H72Z'
            style={{
              fill: '#c084fc',
            }}
          />
          <path
            d='M21.69 21.69h156.63v156.63H21.69z'
            style={{
              fill: 'none',
              stroke: '#fff',
              strokeMiterlimit: 10,
              strokeWidth: '5.94524271965912px',
            }}
          />
        </svg>
      )
    case 'white-lime':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 200 200'
          className={cn(className)}
        >
          <path
            d='M72 135.22h56.1V144H72Z'
            style={{
              fill: '#dcf763',
            }}
          />
          <path
            d='M21.69 21.69h156.63v156.63H21.69z'
            style={{
              fill: 'none',
              stroke: '#fff',
              strokeMiterlimit: 10,
              strokeWidth: '5.94524271965912px',
            }}
          />
          <path
            d='M88.6 374.65c-.75-4.83-5.27-11.2-5.75-16.16l-59.54 13.24c10.28 108.34 74.47 188.34 166.77 218.54 120 39.27 264.76 19.57 382.64-45.3C627.92 620.65 707 679.1 797.2 705.35c64.64 18.79 131.23 21.54 195.63 24.21 34.2 1.41 69.59 2.87 103.4 6.81 146.76 17 269.64 83.86 337.13 183.35a307.53 307.53 0 0 1 52 189.77c-48-18.51-100.7-24.83-151.52-16.27-47.32 8-87.27 27.37-115.53 56.14-35.62 36.29-50.62 86.74-39.14 131.68 13.92 54.46 66.31 95.28 126.82 100.23 3.52.29 7.07.46 10.65.49 51.84.59 104.33-23.12 147.79-66.75 29.17-29.28 51-65 65.45-104.21a213.59 213.59 0 0 1 32.42 35c6.38 8.66 23.33 31.66 22.09 74.06l65.29 1.89c1.25-43.07-10.45-81.66-34.79-114.69a281.4 281.4 0 0 0-67.8-65.1c12.32-86.73-7.12-181.41-59.67-258.86-78.17-115.23-218-192.35-383.66-211.57-36.23-4.19-72.83-5.72-108.23-7.18-63.29-2.63-123.07-5.1-180.09-21.68-75.17-21.86-141.15-70.11-187.76-132.68a459.58 459.58 0 0 0 60.1-52.57c39.43-41.21 85.3-106.76 79.89-185-2.94-42.51-25-84.1-59-111.25-28.83-23-63.08-32.82-96.47-27.64-44.56 6.93-84.78 40.07-104.94 86.48-15 34.51-19.64 75-14.22 123.8 5.69 51.14 21.47 100.63 45.26 146C436.73 545 313 561.73 210.39 528.19c-63.15-20.66-110.12-78.5-121.79-153.54M1473.52 1175c-11.09 35.65-29.59 68-55.37 93.88-30.47 30.6-67.2 47.93-100.77 47.54-34.73-.4-67.63-23-74.92-51.58-5.77-22.59 3-50 22.46-69.74 23.42-23.85 56.29-33.55 79.75-37.5a214.71 214.71 0 0 1 53.1-2.16 232.26 232.26 0 0 1 75.75 19.56ZM667.91 212.11c19.67 15.7 32.92 40.5 34.6 64.71 4 57.36-37.09 109.44-61.92 135.38a398.57 398.57 0 0 1-47.3 42.06A348.79 348.79 0 0 1 558 336.49c-4.13-37.16-1.12-66.78 9.21-90.55 11.15-25.68 32.77-44.5 55.06-48a49.92 49.92 0 0 1 11.7-.43c14.11 1.19 25.91 8.18 33.94 14.6Z'
            style={{
              fill: 'none',
              stroke: '#dcf763',
              strokeMiterlimit: 10,
              strokeWidth: 3,
            }}
          />
          <path
            d='M977.08 1031.54C1033 952 1056.92 857.15 1078.16 773c20.94-82.94 42.59-168.71 89.09-237.55 26.65-39.45 61.35-70.18 98.5-89 3.48 28.19 11.33 57.71 23.71 89.79 13.13 34 41.22 63 75.14 77.49 29 12.39 59.65 13.09 86.44 2 27.06-11.23 48.23-33.75 59.6-63.41 12.61-32.9 11.39-70.85-3.26-101.52-24-50.22-78.46-84.67-142.15-89.9a206.7 206.7 0 0 0-29.75-.27c14.19-62.75 50.5-135 116.52-174.06 66.79-39.55 153.54-39.15 257.85 1.15l23.54-60.93c-123.92-47.88-229.8-46.68-314.67 3.57-94.36 55.88-140.36 162.28-152.29 244.67-52.92 18.97-108.43 57.45-153.31 123.89-52.9 78.32-76 169.72-98.41 258.57C995 835.67 972.6 924.29 923.64 994c-59 84-158.63 138.45-261.12 143.12-1.77.08-3.57.15-5.34.2-86.35 2.48-173.19-30.65-237.3-88.53a251.77 251.77 0 0 0 24.63-22.5c24.13-25.25 53.14-66.08 54.23-117.23C499.89 855.61 465.18 806.13 418 794c-27.33-7.07-56.45-1.59-82 15.41-30 20-50.85 52.77-55.86 87.75-6.13 42.84 7 89 38 134.52-59.69 21.27-138.49 5.46-180-14.67l-37.12 54.74c77.53 47 178.55 49.21 261 12.2 77.57 77.12 187.62 121.84 297 118.71q3.19-.09 6.38-.23c122.34-5.63 241.28-70.67 311.68-170.89ZM401.67 857.19c18 4.65 32.27 27.29 31.77 50.46-.51 23.55-13.34 49.65-36.15 73.5a191.71 191.71 0 0 1-21.29 19.13c-18.33-25.36-36.05-59.79-31.17-93.92 2.35-16.37 13.11-33.11 27.43-42.65 5.17-3.45 12.44-7 20.64-7.41a29.61 29.61 0 0 1 8.77.89ZM1359.88 426c40 3.3 74.77 24.08 88.56 53 7 14.59 7.43 33.74 1.21 50-2.84 7.39-9.68 20.66-23.64 26.45-13.34 5.52-26.78 2.13-35.71-1.69-17.8-7.62-33.09-23.32-39.9-41-12.41-32.13-19.27-59.93-21-86.12a154.3 154.3 0 0 1 30.48-.64Z'
            style={{
              fill: 'none',
              stroke: '#c084fc',
              strokeMiterlimit: 10,
              strokeWidth: 3,
            }}
          />
        </svg>
      )

    case 'black-lime':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 200 200'
          className={cn(className)}
        >
          <path
            d='M72 135.22h56.1V144H72Z'
            style={{
              fill: '#dcf763',
            }}
          />
          <path
            d='M21.69 21.69h156.63v156.63H21.69z'
            style={{
              fill: 'none',
              stroke: '#0f1119',
              strokeMiterlimit: 10,
              strokeWidth: '5.94524271965912px',
            }}
          />
        </svg>
      )

    case 'black-purple':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 200 200'
          className={cn(className)}
        >
          <path
            d='M72 135.22h56.1V144H72Z'
            style={{
              fill: '#c084fc',
            }}
          />
          <path
            d='M21.69 21.69h156.63v156.63H21.69z'
            style={{
              fill: 'none',
              stroke: '#0f1119',
              strokeMiterlimit: 10,
              strokeWidth: '5.94524271965912px',
            }}
          />
        </svg>
      )

    case 'black-white':
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 200 200'
          className={cn(className)}
        >
          <path
            d='M72 135.22h56.1V144H72Z'
            style={{
              fill: '#fff',
            }}
          />
          <path
            d='M21.69 21.69h156.63v156.63H21.69z'
            style={{
              fill: 'none',
              stroke: '#0f1119',
              strokeMiterlimit: 10,
              strokeWidth: '5.94524271965912px',
            }}
          />
        </svg>
      )

    default:
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 200 200'
          className={cn(className)}
        >
          <path
            d='M72 135.22h56.1V144H72Z'
            style={{
              fill: '#c084fc',
            }}
          />
          <path
            d='M21.69 21.69h156.63v156.63H21.69z'
            style={{
              fill: 'none',
              stroke: '#fff',
              strokeMiterlimit: 10,
              strokeWidth: '5.94524271965912px',
            }}
          />
        </svg>
      )
  }
}
